<template>
  <div>
    <h2 v-if="title" class="heading-3 mb-16">
      {{ i18n(title) }}
    </h2>
    <ul class="flex list-none flex-col gap-4">
      <li v-for="(link, index) in links" :key="index">
        <RevLink
          v-if="link.action"
          class="body-2"
          :name="i18n(link.label)"
          :underlined="false"
          @click="link.action"
        >
          {{ i18n(link.label) }}
        </RevLink>

        <RevLink
          v-else-if="link.href"
          class="body-2"
          :name="i18n(link.label)"
          target="_blank"
          :to="link.href"
          :underlined="false"
        >
          {{ i18n(link.label) }}
        </RevLink>

        <RevLink
          v-else-if="link.to"
          class="body-2"
          :name="i18n(link.label)"
          :prefetch="link.prefetch"
          :to="link.to"
          :underlined="false"
        >
          {{ i18n(link.label) }}
        </RevLink>
      </li>
    </ul>
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'

import type { ResolvedFooterLink } from '../config/types'

interface Props {
  title?: I18nDefinition
  links: ResolvedFooterLink[]
}

defineProps<Props>()

const i18n = useI18n()
</script>
